module.exports = __webpack_public_path__ + "img/imagen5.555a4cbc.png";